module.exports = __webpack_public_path__ + "static/assets/9f2c3de75374817482bce6d7ce840f78.png";